import { useEffect } from 'react';
import { logoutUser } from '../../redux/actions/userActions';
import { useDispatch } from 'react-redux';

export default function Logout() {
  const dispatch = useDispatch();

  useEffect(() => {
    (async () => {
      await dispatch(logoutUser());
    })();
  }, []);
  return null;
}
